<mat-chip
  *ngIf="dueDate.formatted"
  [matTooltip]="isOverDue ? overDueTimeString : ('field.dueDate' | translate)"
  [matTooltipPosition]="'above'"
  [ngClass]="{
    'passed-due-date': isOverDue,
    'due-soon-date': isDueSoon,
    'critical-strike-count': isStrikeCount,
  }"
  class="p-tb date-chip-container chip-hover-remove"
  [disableRipple]="true"
  (mouseenter)="onOverDueMouseEnter()"
>
  <div class="d-flex align-items-center">
    <div *ngIf="strikeCount > 0" class="strike-indicator">
      <mat-icon class="strike-icon">close</mat-icon>
      <span *ngIf="strikeCount > 1" class="strike-count">{{ strikeCount }}</span>
    </div>

    <mat-icon
      *ngIf="strikeCount === 0"
      [ngClass]="{
        'passed-due-date': isOverDue,
        'due-soon-date': isDueSoon,
      }"
      class="me-1 style-icon"
    >
      {{ icon }}
    </mat-icon>

    <div class="date-container">
      <span class="date-span">
        {{ dueDate.formatted }}
      </span>
    </div>
  </div>
</mat-chip>